<template>
  <page-column>
    <Header :lang="lang"></Header>
    <div class="banner-c"><img :src="imageConfig.imageList && imageConfig.imageList[0].url"></div>
    <div class="bread-c">
      <div class="left-c">
        <div v-if="lang == 'zh'" style="display: flex;">
          <div @click="$router.push('/' + lang)" style="cursor: pointer;">首页</div>
          <div style="cursor: pointer"> /联系我们</div>
        </div>
        <div v-if="lang == 'en'" style="display: flex;">
          <div @click="$router.push('/' + lang)" style="cursor: pointer;">Home </div>
          <div style="cursor: pointer"> /Contact</div>
        </div>
        <div v-if="lang == 'ja'" style="display: flex;">
          <div @click="$router.push('/' + lang)" style="cursor: pointer;">最初のページ</div>
          <div style="cursor: pointer"> /連絡先</div>
        </div>
      </div>
    </div>
    <div class="contact-c">
      <div class="line-c">
        <div class="ico"></div>
        <div class="name" v-if="lang==='zh'">{{ imageConfig.address_zh }}</div>
        <div class="name" v-if="lang==='en'">{{ imageConfig.address_en }}</div>
        <div class="name" v-if="lang==='ja'">{{ imageConfig.address_ja }}</div>
      </div>
      <div class="line-c">
        <div class="ico1"></div>
        <div class="name" v-if="lang==='zh'">{{ imageConfig.phone_zh }}</div>
        <div class="name" v-if="lang==='en'">{{ imageConfig.phone_en }}</div>
        <div class="name" v-if="lang==='ja'">{{ imageConfig.phone_ja }}</div>
      </div>
      <div class="line-c">
        <div class="ico2"></div>
        <div class="name" v-if="lang==='zh'">{{ imageConfig.fax_zh  }}</div>
        <div class="name" v-if="lang==='en'">{{ imageConfig.fax_en  }}</div>
        <div class="name" v-if="lang==='ja'">{{ imageConfig.fax_ja  }}</div>
      </div>
      <div class="line-c">
        <div class="ico3"></div>
        <div class="name" v-if="lang==='zh'">{{ imageConfig.email_zh }}</div>
        <div class="name" v-if="lang==='en'">{{ imageConfig.email_en }}</div>
        <div class="name" v-if="lang==='ja'">{{ imageConfig.email_ja }}</div>
      </div>
    </div>
    <div style="width:7.0rem;height:4.9rem;margin-left: .22rem;">
      <el-amap vid="amap" :plugin="plugin" class="amap-demo" :zoom="zoom" :center="center">
        <el-amap-marker :position="[120.909, 30.015771]" label="公司地址">
        </el-amap-marker>
      </el-amap>
    </div>
    <div class="button" @click="test">打开导航</div>
  </page-column>
</template>
<script>
import Vue from 'vue'
import VueAMap from 'vue-amap'
VueAMap.initAMapApiLoader({
	key: '863a6c740792539da67b981ad179e802',
	// 插件集合 （插件按需引入）
	plugin: ['AMap.Geolocation'],
	v: '1.4.4'
})
Vue.use(VueAMap)
import Header from '../components/mobile/header.vue'
export default {
  name: 'ContactMobile',
  data() {
    return {
      imageConfig: { indexSecond: '' },
      bgColor: '#fff',
      zoom: 17, // 初始化地图显示层级
      center: [120.909, 30.015771],
      plugin: [{
				enableHighAccuracy: true,//是否使用高精度定位，默认:true
				timeout: 100,          //超过10秒后停止定位，默认：无穷大
				maximumAge: 0,           //定位结果缓存0毫秒，默认：0
				convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
				showButton: true,        //显示定位按钮，默认：true
				buttonPosition: 'RB',    //定位按钮停靠位置，默认：'LB'，左下角
				showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
				showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
				panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
				zoomToAccuracy: true,//定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：f
				extensions: 'all',
				pName: 'Geolocation',
				events: {
					init(o) {
						// o 是高德地图定位插件实例
						o.getCurrentPosition((status, result) => {
							console.log(result)
							if (result && result.position) {
								self.lng = result.position.lng;
								self.lat = result.position.lat;
								self.center = [self.lng, self.lat];
								self.loaded = true;
								self.$nextTick();
							}
						});
					}
				}
			}]
    }
  },
  components: {
    Header
  },
  props: {
    lang: {}
  },
  mounted() {
    this.getImage()
  },
  methods: {
    async getImage() {
      const res = await this.$http.post('contactConfig', { la: 'zh' }) //this.lang
			this.imageConfig = res.data[0] || {}
			if (!this.imageConfig) {
				this.imageConfig = {}
			}
			this.bgColor = this.imageConfig.bgColor
      // this.getPHContent()
    },
    test() {
			
			// this.$http.get('http://api.map.baidu.com/marker?location=40.047669,116.313082&title=我的位置&content=百度奎科大厦&output=html&src=webapp.baidu.openAPIdemo')
			// window.location.href = "http://api.map.baidu.com/marker?location=120.915043,30.020777&title=自立股份&content=自立股份&output=html&src=webapp.baidu.openAPIdemo"
			window.location.href = "https://map.baidu.com/mobile/webapp/place/detail/foo=bar&qt=ninf&wd=%E6%99%AF%E7%82%B9&c=131&searchFlag=sort&center_rank=1&nb_x=13460347.42&nb_y=3484647.23&da_src=unifynearbyclick&uid=83c0f02381ae2703c9213da6&industry=&qid=&pos=&da_ref=&da_qrtp=&da_adquery=&da_adtitle=%E6%B5%99%E6%B1%9F%E8%87%AA%E7%AB%8B%E6%8E%A7%E8%82%A1%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&da_adindus=%E5%85%AC%E5%8F%B8%E4%BC%81%E4%B8%9A;%E5%85%AC%E5%8F%B8&detail_from=list&vt=map"
		},
  }
}
</script>
<style lang="scss" scoped>
.banner-c {
  height: 6.6rem;

  img {
    margin: 0 auto;
    position: absolute;
    left: 0;
    width: 100%;
  }

}

.bread-c {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: .26rem .32rem;
  box-sizing: border-box;
  border-bottom: .02rem solid rgba(0, 0, 0, 0.08);

  .left-c {
    font-size: .28rem;
    color: #666;
  }

  .product-c {
    font-size: .28rem;
    color: #666;
  }
}

.contact-c {
  padding: .32rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .line-c {
    display: flex;
    flex-direction: row;
    font-size: .26rem;
    align-items: center;
    margin-bottom: .12rem;
    .name{
      min-width: 5rem;

    }
    .ico {
      width: .7rem;
      height: .7rem;
      background: url(../assets/images/contact_ico.png) -0px 0px no-repeat;
      background-size: 100%;
    }

    .ico1 {
      width: .7rem;
      height: .7rem;
      background: url(../assets/images/contact_ico.png) -0px -1.1rem no-repeat;
      background-size: 100%;
    }

    .ico2 {
      width: .7rem;
      height: .7rem;
      background: url(../assets/images/contact_ico.png) -0px -1.86rem no-repeat;
      background-size: 100%;
    }

    .ico3 {
      width: .7rem;
      height: .7rem;
      background: url(../assets/images/contact_ico.png) -0px -2.56rem no-repeat;
      background-size: 100%;
    }
  }
}
.button{
  width: 2.2rem;
  height: 1rem;
  text-align: center;
  color: #fff;
  line-height: .8rem;
  background: #0080f0;
  margin: .6rem auto;
}
</style>